import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import LoadPanel from 'devextreme-react/load-panel';
import { useApiConfiguration } from './api/api.configuration';
import { useAppSelector } from './contexts/hooks';

// Componente de fallback mientras carga una página
const PageLoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 200px)',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <LoadPanel visible={true} showIndicator={true} showPane={false} />
    <span style={{ color: '#666', fontSize: '14px' }}>Cargando módulo...</span>
  </div>
);

export default function Content() {
  const { getAllConfig } = useApiConfiguration();
  const FullConfigLoaded = useAppSelector((x) => x.configuration.FullConfigLoaded);

  // Las listas de configuración se cargan aquí, ya autenticados. No bloquea la
  // navegación: las pantallas se montan y se refrescan cuando llega el payload.
  useEffect(() => {
    if (!FullConfigLoaded) {
      getAllConfig();
    }
  }, []);

  return (
    <SideNavBarLayout title={appInfo.title}>
      <Suspense fallback={<PageLoadingFallback />}>
        <Routes>
          {routes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={element}
            />
          ))}
          <Route
            path='*'
            element={<Navigate to='/home' />}
          />
        </Routes>
      </Suspense>
      <Footer>
        Copyright © 2025-{new Date().getFullYear()} Neurasoft Solution SAS .
        <br />
        Todos los derechos reservados.
      </Footer>
    </SideNavBarLayout>
  );
}

